export default __webpack_public_path__ + "static/media/Hauora-Medium.b00a4a12.woff2";